<template>
    <div id="app" :class="{active: ['ar', 'ur', 'ps','fa','he'].includes($i18n.locale)}">
            <!-- <nav class="header_app shadow-2">
                <div class="language-button">
                    <div class="language-container">
                        <div class="language-icon" v-on:click="showLanguage">
                            <img src="./assets/img/938.png" alt="logolang" />
                        </div>
                    </div>
                </div>
                <div class="spanLanguage" v-bind:class="{ active: isActive }" v-on:click="showLanguage">
                    <div class="chooseLanguage d-none">
                        <div
                            class="language-item" v-bind:class="{active : (lst.code == $i18n.locale)}"
                            v-for="(lst, index) in getLang"
                            v-bind:key="index"
                            v-on:click="changeLanguage(lst.code)">
                            {{lst.name}} 
                        </div>
                    </div>
                </div>
                <router-link :to="{ name: 'Home'}"><img class="logo" src="./assets/img/LOGO_AHA.png" /></router-link>
            </nav> -->

        <router-view/> 
        <footer class="game-footer">
            <strong> {{ $t("disclaimer") }} </strong>
            {{ $t("disclaimer_message") }}
        </footer>
    </div>
</template>

<script>
import './assets/css/style.css';
import { mapGetters, mapActions } from 'vuex'
export default {
    name: "App",
    data() {
        return {
            isActive: false,
        };
    },
    watch: {
        
    },
    mounted: function() {
    },
    created: function() {
        
    },
    computed: {
        ...mapGetters(["getLang", "getEntry", "getUserInfo"]),
    },
    methods: {
    }
};

</script>
